<template>
  <v-card class="new-barrier-card" flat outlined>
    <v-form ref="formAddBarrier" v-model="valid" lazy-validation>
      <v-card-text class="new-barrier-card__body">
        <v-row>
          <v-col cols="12" sm="5" class="new-barrier-card__form-col">
            <h3 class="new-barrier-card__section-title">
              <v-icon left small>mdi-information-outline</v-icon>
              Данные об объекте
            </h3>
            <v-menu
              v-model="menuInstallationDate"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="190px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="installationDateTime"
                  label="Дата установки"
                  outlined
                  dense
                  hide-details
                  clearable
                  class="new-barrier-card__field pb-4"
                  v-on="on"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                ></v-text-field>
              </template>
              <v-date-picker v-model="dateBarrier" @click="menuInstallationDate = false"></v-date-picker>
            </v-menu>
            <v-autocomplete
              label="Направление движения"
              :items="entryRemoteControls"
              item-text="text"
              item-value="value"
              v-model='formBarrier.entryRemoteControl'
              :rules='rules.required'
              type="string"
              prepend-inner-icon="mdi-arrow-decision-outline"
              class="new-barrier-card__field"
              outlined
              dense
              flat
              clearable
            />
            <v-autocomplete
              label="Тип открытия"
              :items="filteredOpeningTypes"
              item-text="text"
              item-value="value"
              v-model='formBarrier.openingType'
              :rules='rules.requiredArray'
              type="string"
              prepend-inner-icon="mdi-lock-open"
              class="new-barrier-card__field"
              outlined
              dense
              flat
              multiple
              :menu-props="{ closeOnContentClick: false }"
              clearable
            >
              <template v-slot:selection="{ index }">
                <span v-if="index === 0" class="text-caption grey--text text--darken-1">
                  Выбрано: {{ selectedOpeningTypes.length }}
                </span>
              </template>
            </v-autocomplete>
            <div v-if="selectedOpeningTypesText" class="new-barrier-card__opening-summary">
              {{ selectedOpeningTypesText }}
            </div>
            <v-autocomplete
              label="Открытие по пультам"
              :items="directionMovements"
              item-text="text"
              item-value="value"
              v-model='formBarrier.directionMovement'
              :rules='rules.required'
              prepend-inner-icon="mdi-remote"
              class="new-barrier-card__field"
              outlined
              dense
              flat
              clearable
            />
            <h3 class="new-barrier-card__section-title">
              <v-icon left small>mdi-account-outline</v-icon>
              Данные о клиенте
            </h3>
            <v-combobox
              v-model="formBarrier.address"
              @keyup="startTypingTimer"
              :rules="rules.required"
              :items="addresses"
              item-text="addresses"
              :search-input.sync="searchAddress"
              prepend-inner-icon="mdi-rename-box-outline"
              class="new-barrier-card__field"
              return-object
              flat
              label="Адрес"
              outlined
              dense
            ></v-combobox>

            <v-autocomplete
              label="Район (только для г. Саранск)"
              :items="district"
              :item-text="item => (item.name) + ' (' + displayCity(item.city_id) + ')'"
              item-value="id"
              prepend-inner-icon="mdi-map-marker-radius-outline"
              class="new-barrier-card__field"
              v-model='formBarrier.region'
              type="string"
              outlined
              :disabled="!isDistrict"
              dense
              flat
              clearable
            />

            <v-text-field
              label="Название в моб. приложении"
              v-model='formBarrier.name'
              prepend-inner-icon="mdi-rename-outline"
              class="new-barrier-card__field"
              :rules="rules.required"
              type="string"
              outlined
              dense
              flat
            ></v-text-field>
            <v-autocomplete
              label="Управляющая компания"
              :items="managementCompanies"
              item-text="name"
              item-value="id"
              @change="setGroupManagement"
              v-model='formBarrier.managementCompany'
              prepend-inner-icon="mdi-home-account"
              class="new-barrier-card__field"
              type="string"
              outlined
              dense
              flat
              clearable
            />
            <v-text-field
              label="Компания-собственник"
              v-model='formBarrier.groupManagement'
              prepend-inner-icon="mdi-shield-account"
              class="new-barrier-card__field"
              type="string"
              outlined
              dense
              flat
              disabled
            ></v-text-field>
            <v-autocomplete
              label="Тип договора на обслуживание"
              :items="contractTypes"
              v-model="formBarrier.contractType"
              prepend-inner-icon="mdi-file-document-edit-outline"
              class="new-barrier-card__field"
              item-text="text"
              item-value="value"
              outlined
              dense
              flat
              required
              clearable
            ></v-autocomplete>
            <v-text-field
              label="Комментарий"
              v-model='formBarrier.comment'
              prepend-inner-icon="mdi-comment"
              class="new-barrier-card__field"
              type="string"
              outlined
              dense
              flat
              clearable
            ></v-text-field>
<!--            :rules="(formBarrier.oldBarrier || formBarrier.openingType !== 'G') ? rules.phone : []"-->
            <v-text-field
              label="Номер телефона для звонка на устройство"
              v-if="showBarrierOpenPhone"
              v-model="formBarrier.barrierOpenPhone"
              prepend-inner-icon="mdi-phone"
              class="new-barrier-card__field"
              outlined
              dense
              flat
            ></v-text-field>
            <v-autocomplete
              label="Плательщик"
              :items="payers"
              v-if="formBarrier.oldBarrier"
              :rules="formBarrier.oldBarrier ? rules.required : []"
              v-model='formBarrier.payer'
              prepend-inner-icon="mdi-account-card-outline"
              class="new-barrier-card__field"
              item-text="text"
              item-value="text"
              outlined
              dense
              flat
              required
            ></v-autocomplete>
            <h3 class="new-barrier-card__section-title">
              <v-icon left small>mdi-chip</v-icon>
              Данные о физическом устройстве
            </h3>
            <v-autocomplete
              label="Модель шлагбаума"
              :items="barrierModels"
              v-model="formBarrier.modelBarrier"
              prepend-inner-icon="mdi-globe-model"
              class="new-barrier-card__field"
              item-text="text"
              item-value="value"
              outlined
              dense
              flat
              required
              clearable
            ></v-autocomplete>
            <v-autocomplete
              label="Тип модуля GSM"
              :items="gsmModuleTypes"
              v-model="formBarrier.gsmModuleType"
              prepend-inner-icon="mdi-cellphone-wireless"
              class="new-barrier-card__field"
              item-text="text"
              item-value="value"
              outlined
              dense
              flat
              required
              clearable
            ></v-autocomplete>
            <v-autocomplete
              label="Тип пультов"
              :items="remoteControlTypes"
              v-model="formBarrier.remotes"
              prepend-inner-icon="mdi-remote"
              class="new-barrier-card__field"
              item-text="text"
              item-value="value"
              outlined
              dense
              flat
              required
              clearable
            ></v-autocomplete>
            <v-autocomplete
              label="Магнитная петля"
              :items="magneticLoopTypes"
              v-model="formBarrier.magneticLoop"
              prepend-inner-icon="mdi-magnet"
              class="new-barrier-card__field"
              item-text="text"
              item-value="value"
              outlined
              dense
              flat
              required
              clearable
            ></v-autocomplete>
            <v-autocomplete
              label="GSM модуль"
              :items="freeGsmDevices"
              v-model="formBarrier.gsmModuleDeviceId"
              prepend-inner-icon="mdi-cellphone-link"
              class="new-barrier-card__field"
              item-text="displayText"
              item-value="id"
              outlined
              dense
              flat
              clearable
              :disabled="!selectedDevices.length"
            ></v-autocomplete>
            <v-checkbox
              class="new-barrier-card__checkbox mt-0"
              v-model="displayApplication"
              label="Отображение в приложении"
              hide-details
              color="success"
            />
            <v-checkbox
              label="Старый шлагбаум (старого образца)"
              class="new-barrier-card__checkbox mb-0"
              v-model="formBarrier.oldBarrier"
              @click="handleCheckboxClick"
            >
            </v-checkbox>
            <BaseNewBindingDoorphone
              @addDoorphones="handleAddDoorphones"
              @deleteDoorphones="handleDeleteDoorphones"
              :selected-devices="selectedDevices"
              :is-old-device="formBarrier.oldBarrier"
              :is-filters-manufacturer="false"
            />
          </v-col>
          <v-col class="pb-0 new-barrier-card__devices-col">
            <v-card class="new-barrier-card__devices" flat outlined :disabled="formBarrier.oldBarrier">
              <div class="new-barrier-card__devices-header">
                <v-icon left small>mdi-devices</v-icon>
                <span>Устройства</span>
              </div>
              <div class="new-barrier-card__devices-search">
                <v-text-field
                  v-model="searchDevice"
                  label="Поиск по IP адресу"
                  dense
                  flat
                  outlined
                  hide-details
                  prepend-inner-icon="mdi-magnify"
                  class="new-barrier-card__field"
                  autocomplete="chrome-off"
                  @keyup="(e) => e.keyCode === 13 && filterDevices()"
                />
                <v-btn
                  color="primary"
                  class="text-none"
                  dark
                  rounded
                  @click.prevent="filterDevices"
                >
                  <v-icon left small>mdi-magnify</v-icon>
                  Поиск
                </v-btn>
              </div>
              <v-data-table
                class="table"
                v-model="selectedDevices"
                :options.sync="universalOptions"
                :server-items-length="universalTotalDevices"
                :headers="headersDevices"
                :items="devices"
                item-key="id"
                show-select
                :footer-props="{
                    'items-per-page-options': [10, 20, 50, 100],
                  }"
                :single-select="true"
                :disable-sort="true"
              >
              </v-data-table>
            </v-card>
            <v-col v-if="errorDevice" cols="12" class="mt-2 new-barrier-card__error-col">
              <v-alert
                type="error"
                dense
                outlined
              >
                Выберите устройство
              </v-alert>
            </v-col>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="new-barrier-card__actions">
        <v-btn
          color="primary"
          class="text-none"
          rounded
          @click="validate()"
        >
          <v-icon left>mdi-content-save-outline</v-icon>
          Сохранить
        </v-btn>
        <v-btn
          color="primary"
          outlined
          rounded
          class="text-none ml-2"
          @click.prevent="returnBarriers()"
        >
          <v-icon left>mdi-close</v-icon>
          Отменить
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { headersDevices } from '../../../doorphone/EditDoorphone/consts';
import watchTableOptions from '../../../../mixins/watchTableOptions';
import BaseNewBindingDoorphone from '@/components/BaseNewBindingDoorphone';
import {
  entryRemoteControls,
  openingTypes,
  accessAreas,
  directionMovements,
  payers,
  rules, ENUM_LABELS,
} from '../../consts';

export default {
  name: 'NewBarrier',
  mixins: [watchTableOptions],
  components: { BaseNewBindingDoorphone },
  props: {
    typeBarrier: String,
  },
  data () {
    return {
      valid: true,
      searchDevice: '',
      installationDate: '',
      dateBarrier: new Date().toISOString().substr(0, 10),
      menuInstallationDate: false,
      landscape: false,
      isCreated: false,
      isFirstLoading: false,
      loading: true,
      searchAddress: '',
      isDistrict: false,
      displayApplication: true,
      payers,
      ENUM_LABELS,
      value: '',
      universalTotalDevices: 0,
      typingTimer: null,
      universalOptions: {
        itemsPerPage: 10,
        page: 1,
        sortBy: [],
        sortDesc: [],
      },
      headersDevices,
      selectedDevices: [],
      selectedDoorphones: [],
      errorDevice: false,
      freeGsmDevices: [],
      entryRemoteControls,
      openingTypes,
      accessAreas,
      directionMovements,
      formBarrier: {
        address: '',
        region: null,
        entryRemoteControl: '',
        openingType: [],
        accessArea: '',
        directionMovement: '',
        managementCompany: '',
        groupManagement: '',
        name: '',
        barrierOpenPhone: '',
        isWithoutPrefix: false,
        oldBarrier: false,
        payer: '',
        modelBarrier: '',
        gsmModuleType: '',
        remotes: '',
        magneticLoop: '',
        contractType: '',
        comment: '',
        gsmModuleDeviceId: null,
      },
      barrierModels: Object.entries(ENUM_LABELS.model_barrier).map(([key, value]) => ({
        text: value,
        value: key,
      })),
      gsmModuleTypes: Object.entries(ENUM_LABELS.gsm_module_type).map(([key, value]) => ({
        text: value,
        value: key,
      })),
      remoteControlTypes: Object.entries(ENUM_LABELS.remotes).map(([key, value]) => ({
        text: value,
        value: key,
      })),
      magneticLoopTypes: Object.entries(ENUM_LABELS.magnetic_loop).map(([key, value]) => ({
        text: value,
        value: key,
      })),
      contractTypes: Object.entries(ENUM_LABELS.contract_type).map(([key, value]) => ({
        text: value,
        value: key,
      })),
      rules,
      searchCity: '',
      searchStreet: '',
    };
  },
  computed: {
    ...mapGetters({
      devices: 'Device/devices',
      addresses: 'Doorphone/addresses',
      district: 'Doorphone/districts',
      managementCompanies: 'ManagementCompany/managementCompanies',
    }),
    installationDateTime () {
      if (this.dateBarrier) {
        const date = new Date(this.dateBarrier);
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return date.toLocaleDateString('ru-RU', options);
      } else {
        return '';
      }
    },
    filteredOpeningTypes () {
      if (this.formBarrier.oldBarrier) {
        return this.openingTypes.filter(item => ['C', 'RC'].includes(item.value));
      }
      return this.openingTypes;
    },
    selectedOpeningTypes () {
      if (!this.formBarrier.openingType) return [];
      return Array.isArray(this.formBarrier.openingType) ? this.formBarrier.openingType : [this.formBarrier.openingType];
    },
    selectedOpeningTypesText () {
      if (!this.selectedOpeningTypes.length) return '';
      return this.selectedOpeningTypes
        .map(type => (this.openingTypes.find(item => item.value === type) || {}).text)
        .filter(Boolean)
        .join(', ');
    },
    showBarrierOpenPhone () {
      return this.selectedOpeningTypes.includes('C');
    },
  },
  watch: {
    universalOptions (curr, prev) {
      this.handleOptionsChange(curr, prev, () => {
        this.universalChangePage();
      });
    },
  },
  methods: {
    ...mapActions({
      loadDevices: 'Device/getDevices',
      newBarrier: 'Barriers/newBarrier',
      getAddressSearch: 'Doorphone/getAddressSearch',
      getStatusCondition: 'Barriers/getStatusCondition',
    }),
    formatGsmDeviceDisplayText (device) {
      const parts = [];

      if (device.gsm_phone) {
        const phoneDigits = device.gsm_phone.replace(/\D/g, '');
        const displayPhone = phoneDigits.length === 10 ? '7' + phoneDigits : device.gsm_phone;
        parts.push(displayPhone);
      }

      if (device.city_phone_number?.phone_number) {
        parts.push(`(${device.city_phone_number.phone_number})`);
      }

      if (device.model) {
        parts.push(`- ${device.model}`);
      }

      if (device.manufacturer) {
        parts.push(`(${device.manufacturer})`);
      }

      return parts.join(' ');
    },
    loadFreeGsmDevices () {
      this.loadDevices({
        filters: {
          type: 'G',
          free: 1,
        },
        pagination: 0,
      })
        .then((response) => {
          this.freeGsmDevices = (response.devices || []).map(device => ({
            id: device.id,
            displayText: this.formatGsmDeviceDisplayText(device),
          }));
        })
        .catch((error) => {
          console.error(error);
          this.$flash_warning('Ошибка при загрузке GSM модулей');
        });
    },
    validateKeyUp (e) {
      if (e.keyCode === 13) {
        this.filterDoorphones();
      }
    },
    handleCheckboxClick () {
      this.selectedDevices = [];
      this.displayApplication = false;
      if (this.selectedOpeningTypes.length) {
        this.formBarrier.openingType = this.selectedOpeningTypes.filter(type => ['C', 'RC'].includes(type));
      }
    },
    displayCity (item) {
      switch (item) {
        case 1: return 'Ульяновск';
        case 2: return 'Саранск';
        default: return '';
      }
    },
    handleAddDoorphones (data) {
      this.selectedDoorphones = data;
    },
    handleDeleteDoorphones (itemToDelete) {
      this.selectedDoorphones = this.selectedDoorphones.filter(doorphone => doorphone !== itemToDelete.id.toString());
    },
    updateAddressSearch () {
      const val = this.formBarrier.address;
      if (val && this.isDistrict) {
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(() => {
          if (!this.isFirstLoading && val) {
            this.getAddressSearch({
              value: val,
            })
              .then((res) => {
                this.formBarrier.region = null;
                this.isDistrict = !!res.districts[0];
              });
          }
        }, 600);
      }
    },
    startTypingTimer (val) {
      clearTimeout(this.typingTimer);
      this.typingTimer = setTimeout(() => {
        if (!this.isFirstLoading && val.srcElement._value) {
          this.getAddressSearch({
            value: val.srcElement._value,
          })
            .then((res) => {
              this.region = null;
              this.isDistrict = !!res.districts[0];
            });
        }
      }, 600);
    },
    setGroupManagement (groupCompanyId) {
      const company = this.managementCompanies.find(item => item?.id === groupCompanyId);
      if (company) {
        const management = company.management_group;
        this.formBarrier.groupManagement = management?.name ?? 'Нет группы';
      } else {
        this.formBarrier.groupManagement = '';
      }
    },
    filterDevices () {
      this.universalOptions.page = 1;
      this.universalChangePage();
    },
    universalChangePage () {
      const filters = { free: 1, model_id: '7,8' };
      if (this.searchDevice) {
        filters.ip_address = this.searchDevice;
      }
      return this.loadDevices({
        pagination: 1,
        limit: this.universalOptions.itemsPerPage,
        page: this.universalOptions.page,
        filters,
      })
        .then((response) => {
          this.universalTotalDevices = response.meta.total;
        });
    },
    async validate () {
      this.errorDevice = false;
      if (!this.validateInputs()) return;
      const tempBarrier = this.buildBarrierObject();
      await this.submitBarrier(tempBarrier);
    },

    validateInputs () {
      if (!this.formBarrier.oldBarrier && !this.selectedDevices.length) {
        this.$flash_danger('Заполните все поля');
        this.errorDevice = true;
        this.$refs.formAddBarrier.validate();
        return false;
      }

      if (!this.formBarrier.oldBarrier && (!this.selectedDoorphones || this.selectedDoorphones.length < 1)) {
        this.$flash_danger('Привяжите домофон');
        return false;
      }

      if (this.isDistrict && this.formBarrier.region === null) {
        this.$flash_danger('Заполните поле "Район"');
        return false;
      }

      if (!this.$refs.formAddBarrier.validate()) {
        this.$flash_danger('Заполните все поля');
        return false;
      }

      return true;
    },

    buildBarrierObject () {
      const tempBarrier = {
        address: this.formBarrier.address,
        without_device: this.formBarrier.oldBarrier,
        passage_type: this.typeBarrier,
        direction: this.formBarrier.entryRemoteControl,
        opening_type: this.selectedOpeningTypes,
        display_in_app: this.displayApplication,
        installed_at: this.dateBarrier ? this.dateBarrier.split('T')[0] + ' 00:00:00' : null,
        barrier_open_phone: this.showBarrierOpenPhone ? (this.formBarrier.barrierOpenPhone || null) : null,
      };

      if (this.selectedDoorphones.length) {
        tempBarrier.doorphones = this.selectedDoorphones;
      }

      if (this.formBarrier.managementCompany) {
        tempBarrier.management_company_id = this.formBarrier.managementCompany;
      }

      if (this.formBarrier.region && this.isDistrict) {
        tempBarrier.region_id = this.formBarrier.region;
      }
      if (!this.formBarrier.oldBarrier) {
        tempBarrier.device_id = this.selectedDevices[0].id;
      } else {
        Object.assign(tempBarrier, {
          physical_status: 5,
          payer: this.formBarrier.payer,
          barrier_open_phone: this.formBarrier.barrierOpenPhone,
        });
      }

      const optionalFields = [
        'name', 'modelBarrier', 'gsmModuleType', 'remotes',
        'magneticLoop', 'contractType', 'comment',
      ];

      optionalFields.forEach(field => {
        if (this.formBarrier[field]) {
          tempBarrier[field.replace(/([A-Z])/g, '_$1').toLowerCase()] = this.formBarrier[field];
        }
      });

      if (this.formBarrier.directionMovement) {
        tempBarrier.remote_control = this.formBarrier.directionMovement === '1';
      }

      if (this.formBarrier.gsmModuleDeviceId) {
        tempBarrier.gsm_module_device_id = this.formBarrier.gsmModuleDeviceId;
      }

      return tempBarrier;
    },

    async submitBarrier (tempBarrier) {
      try {
        const response = await this.newBarrier(tempBarrier);
        const createdBarrierId = response.data.barrier_id;

        await this.returnBarriers();

        this.$flash_success(this.typeBarrier === 'B' ? 'Шлагбаум успешно создан' : 'Ворота успешно созданы');

        if (!this.formBarrier.oldBarrier && this.selectedDevices[0].model !== 'RACS-1101') {
          await this.getStatusCondition({ id: createdBarrierId });
        }
      } catch (error) {
        this.$sentry_exception(error);
        this.$flash_warning('Ошибка при добавлении барьера');
      }
    },
    async returnBarriers () {
      await this.$router.push({ name: 'Barriers' });
    },
  },
  created () {
    this.universalChangePage()
      .catch((error) => {
        this.$sentry_exception(error);
        this.$flash_warning('Не удалось загрузить список устройств');
      });
    this.loadFreeGsmDevices();
    setTimeout(() => this.$nextTick(() => {
      this.isFirstLoading = false;
    }));
  },
};
</script>

<style lang="scss" scoped>
.new-barrier-card {
  border-radius: 12px;
}

.new-barrier-card__body {
  padding: 24px;
}

.new-barrier-card__form-col {
  padding-top: 8px;
}

.new-barrier-card__section-title {
  font-size: 1rem;
  font-weight: 500;
  color: #546e7a;
  margin: 0 0 12px 0;
  padding-top: 16px;
}

.new-barrier-card__section-title:first-child {
  padding-top: 0;
}

.new-barrier-card__field ::v-deep .v-input__prepend-inner .v-icon {
  color: rgba(0, 0, 0, 0.5);
}

.new-barrier-card__checkbox {
  margin-left: 12px;
}

.new-barrier-card__opening-summary {
  margin-top: -8px;
  margin-bottom: 12px;
  color: rgba(0, 0, 0, 0.72);
  font-size: 0.8rem;
  line-height: 1.35;
}

.new-barrier-card__devices-col {
  padding-top: 8px;
}

.new-barrier-card__devices {
  border-radius: 12px;
}

.new-barrier-card__devices-header {
  display: flex;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  font-size: 1rem;
  font-weight: 500;
  color: #546e7a;
}

.new-barrier-card__devices-search {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 12px;
  padding: 16px 20px;
}

.new-barrier-card__devices-search .new-barrier-card__field {
  flex: 1;
  min-width: 200px;
}

.new-barrier-card__actions {
  padding: 16px 24px;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 0;
}
</style>
